/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum DependencyLinkageType {
	FinishToStart = 'FS',
	StartToStart = 'SS',
	FinishToFinish = 'FF',
	StartToFinish = 'SF',
}
